const SHOP_LOGOS: Record<string, string> = {
  Baitukas: "/images/shops/baitukas.png",
  BoardGamePrices: "/images/shops/boardgameprices.svg",
  "Brain Games LT": "/images/shops/brain_games_lt.jpg",
  Darkwood: "/images/shops/darkwood.png",
  "E-vaikas": "/images/shops/e_vaikas.png",
  Eduko: "/images/shops/eduko.png",
  Edukaciniai: "/images/shops/edukaciniai.png",
  Ermitazas: "/images/shops/ermitazas.png",
  Gameroom: "/images/shops/gameroom.png",
  Hobi: "/images/shops/hobi.png",
  "Hobbyshop.lt": "/images/shops/hobbyshop_lt.png",
  Houstera: "/images/shops/houstera.png",
  Jumspigiau: "/images/shops/jumspigiau.png",
  Junika: "/images/shops/junika.png",
  Kudikiuprekes: "/images/shops/kudikiuprekes.png",
  Lizeja: "/images/shops/lizeja.png",
  Ludu: "/images/shops/ludu.png",
  Magyzaislai: "/images/shops/magyzaislai.png",
  Manohobis: "/images/shops/manohobis.png",
  "Miplas.lt": "/images/shops/miplas_lt.png",
  Modeliukai: "/images/shops/modeliukai.png",
  Pegasas: "/images/shops/pegasas.png",
  Rde: "/images/shops/rde.png",
  Rimi: "/images/shops/rimi.png",
  Rududu: "/images/shops/rududu.png",
  Savu: "/images/shops/savu.png",
  Seimosparduotuve: "/images/shops/seimosparduotuve.png",
  Skilsas: "/images/shops/skilsas.png",
  Skytech: "/images/shops/skytech.png",
  Smartonly: "/images/shops/smartonly.png",
  Smartworld: "/images/shops/smartworld.png",
  "Stalo Žaidimai": "/images/shops/stalozaidimai.jpg",
  Store24: "/images/shops/store24.png",
  "Terra Publica": "/images/shops/terrapublica.png",
  Topocentras: "/images/shops/topocentras.png",
  "Toys.lt": "/images/shops/toys_lt.png",
  Tulli: "/images/shops/tulli.png",
  Vaga: "/images/shops/vaga.png",
  Vitalimax: "/images/shops/vitalimax.png",
  "XS Žaislai": "/images/shops/xszaislai.png",
  Zaisliukai: "/images/shops/zaisliukai.png",
  Zaisluturgus: "/images/shops/zaisluturgus.png",
};

export function getShopLogoUrl(shopName: string): string | null {
  return SHOP_LOGOS[shopName] ?? null;
}
